import React from 'react';
import { Input, Select, InputNumber } from 'antd';
import vdns_api from '../../services/vdns_api';
import Config from '../../Config';

const Option = Select.Option;

/* eslint-disable react/display-name */

export default async function getClustersTableColumns(authToken) {
  const services = await vdns_api.getAllServices(authToken);

  return [
    {
      title: 'Cluster Name',
      dataIndex: 'name',
      editable: true,
      getInput: () => <Input />,
      required: true
    },
    {
      title: 'Service',
      dataIndex: 'serviceId',
      required: true,
      editable: true,
      render: function(text, cluster, id) {
        const service = services && services.data.find(service => service.id === cluster.serviceId);
        return service.name;
      },
      getInput: () => {
        return (
          <Select>
            { services && services.data.map(service => (<Option value={service.id} key={service.id}>{service.name}</Option>))}
          </Select>
        );
      }
    },
    {
      title: 'Priority',
      dataIndex: 'priority',
      editable: true,
      getInput: () => <InputNumber
        min={Config.PRIORITY_MIN_VAL}
        max={Config.PRIORITY_MAX_VAL}
      />,
      required: true
    },
    {
      title: 'TTL',
      dataIndex: 'ttl',
      editable: true,
      getInput: () => <InputNumber
        min={Config.TTL_MIN_VAL}
        max={Config.TTL_MAX_VAL}
      />,
      required: true
    }
  ];
}